import React, { useCallback, useEffect, useRef, useState } from 'react'
import Dropdown from '../Dropdown/Dropdown';
import CustomDateRangePicker from '../CustomDateRangePicker/CustomDateRangePicker';
import modelList from '../../assets/data/modelname.json';
import { useLocation } from 'react-router-dom';
import { useAdminDashboardService } from '../../services/adminDashboardService';
import { useDispatch, useSelector } from 'react-redux';
import { resetFilters, setCurrentPage, setDateRange } from '../../redux/adminDashboardSlice';
import spinner from '../../assets/images/spinner.png';
import { MdRefresh } from "react-icons/md";


const ratingList = ["0", "1", "2", "3", "4", "5"];

const AdminNavbar = ({ users, fonts }) => {
    const loaction = useLocation()
    const dispatch = useDispatch()
    const { fetchFilteredData, fetchOverAllRating,
        fetchOverAllRatingResult,
        fetchFeedbackComments,
        fetchFeedback1Rating,
        fetchFeedback2Rating,
        fetchFeedback3Rating } = useAdminDashboardService()

    const {
        selectedModel,
        selectedRating,
        selectedEmail,
        selectedFont,
        selectedDateRange,
        currentPage,
        previousPage,
        loadingHistory,
        analyticsLoading
    } = useSelector((state) => state.adminDashboard);


    const [isDateRangeOpen, setIsDateRangeOpen] = useState(false);
    const [isResetting, setIsResetting] = useState(false);
    const [searchValue, setSearchValue] = useState('')
    

    const handleApply = () => {
        fetchFilteredData(1, searchValue)
        fetchOverAllRating()
        fetchOverAllRatingResult()
        fetchFeedbackComments()
        fetchFeedback1Rating()
        fetchFeedback2Rating()
        fetchFeedback3Rating()
    }
    const abortController = useRef();


    const handleReset = () => {
        setIsResetting(true);
        dispatch(resetFilters());
    };

    const debounce = (func, delay) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    };

    const fetchFilteredDatas = useCallback(() => {
        if (abortController.current) abortController.current.abort();
        abortController.current = new AbortController();
        
        // if (currentPage===1 && previousPage===0) return;
        
        fetchFilteredData(1, searchValue, abortController.current.signal);
    }, [searchValue]);

    useEffect(() => {
        return () => {
          if (abortController.current) {
            abortController.current.abort();
          }
        };
      }, []);

    useEffect(() => {
        fetchFilteredDatas();
        console.log('fetchFilteredDatas', previousPage, currentPage)
    }, [fetchFilteredDatas]);



    useEffect(() => {
        if (isResetting) {
            handleApply();
            setIsResetting(false);
        }
    }, [selectedModel, selectedRating, selectedEmail, selectedFont, selectedDateRange, isResetting, searchValue]);

    return (
        <div className='sticky top-[0px] z-10  w-full h-[100px]  border-y bg-white'>
            <div className='h-[50px] pl-[24px] flex items-center justify-between border-b'>
                <div className='flex items-center'>
                    <div className='flex items-center gap-[16px]'>
                        <h1 className='text-[28px] font-helveticaDisp-Bold text_cus_primary leading-[48px] tracking-[-0.02em] font-[700] '>
                            {loaction.pathname === '/admin/dashboard' ? 'User history ' : 'Analytics'}
                        </h1>
                        {loadingHistory && <img src={spinner} alt="loading" className='animate-spin' />}
                    </div>
                </div>
                <div className='h-full flex'>
                    <Dropdown handleApply={handleApply} data={modelList} title="Select Model" id="model" />
                    <Dropdown handleApply={handleApply} data={users} title="Email" id="email" />
                    {loaction.pathname === '/admin/dashboard' ?
                        <Dropdown handleApply={handleApply} data={ratingList} title="Rating" id="rating" /> :
                        <Dropdown handleApply={handleApply} data={fonts} title="Select Font" id="font" />
                    }
                    <CustomDateRangePicker
                        isDatePickerOpen={isDateRangeOpen}
                        setIsDatePickerOpen={setIsDateRangeOpen}
                    />
                    <button
                        onClick={handleReset}
                        disabled={loadingHistory || analyticsLoading}
                        className="w-[150px] border-l flexCenter gap-[8px] h-full cursor-pointer hover:bg-pink-light hover:text-pink-dark transition transform active:scale-95 active:bg-blue-light"
                    >
                        <MdRefresh className='transition rotate-90' />
                        <span>Reset All</span>
                    </button>
                </div>
            </div>
            <div className='h-[50px] px-[24px] py-[5px] flex items-centera '>
                <input type="text"
                    className='w-full h-full outline-none'
                    placeholder='Search by prompt'
                    value={searchValue}
                    onChange={(e) => { setSearchValue(e.target.value); }}
                />
            </div>
        </div>
    )
}

export default AdminNavbar